import React, { useEffect, useState } from "react";
import Landing from "./components/Landing";
import HubShell from "./components/HubShell";

const loadUser = () => {
  try {
    const stored = window.localStorage.getItem("hubUser");
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(loadUser());
  }, []);

  const handleAuthSuccess = (newUser) => {
    setUser(newUser);
  };

  const handleSignOut = () => {
    window.localStorage.removeItem("hubUser");
    setUser(null);
  };

  if (!user) {
    return <Landing onAuthSuccess={handleAuthSuccess} />;
  }

  return <HubShell user={user} onSignOut={handleSignOut} />;
}

export default App;
